import { Injectable } from '@angular/core';
import { AsyncValidator, ValidationErrors, FormControl } from '@angular/forms';
import { of } from 'rxjs';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { UserService } from 'src/core/services/administration/user.service';

@Injectable({ providedIn: 'root' })
export class UserPbxAgentIdValidator implements AsyncValidator {
  userId: string | null;
  isActive: boolean;

  constructor(private userService: UserService) {}

  validate(
    formControl: FormControl
  ): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> {
    const id = this.userId == null ? '' : this.userId;
    const pbxAgentId = formControl.value;
    if (pbxAgentId == null || pbxAgentId == '') {
      return of(null);
    }
    if (!this.isActive) {
      return of(null);
    }
    return this.userService.getByPbxAgentId(pbxAgentId, id).pipe(
      map(
        response => {
          return response !== null && response === true ? { pbxAgentIdInUse: true } : null;
        },
        catchError(() => {
          return null;
        })
      )
    );
  }
}
